import React, { useCallback } from "react";
import { Grid } from 'semantic-ui-react'
import {InputField} from 'KN-EU-Broker-Dashboard-UI'
import List from "../../commonComponents/List";
import { dropdownLabelVal } from "../../../constants";
import DropDownLabel from "../../commonComponents/DropdownLabel";
import useEntrySummaryData from "../../../hooks/useEntrySummaryData";

const EntrySummaryForm = ({formData, onChange}) => {
    const {reconciledEntryId} = formData;
    const { orgRevenueDetails, reconRevenueDetails } = formData;
    const orgDynamicField = Object.keys(orgRevenueDetails).filter((item) => {
        if(item !== "DUTY" && item !== "HARBOR MAINTENANCE FEE" && item !== "FORMAL MERCHANDISE PROCESSING FEE"){
            return item;
        }
    })
    const fieldsData = useEntrySummaryData(formData);
    const rednerItem = useCallback((fieldData, key) => {
        return ( 
            <Grid.Column key={key} width={1}>
                <InputField
                    onChange={onChange}
                    {...fieldData}
                />
            </Grid.Column>
         );
    }, [])
    return ( <>
        <Grid.Row>
            <List renderItem={rednerItem} data={fieldsData} />
            <Grid.Column>
                <InputField 
                    labelClassName="dropdown-label"
                    label={<DropDownLabel value={orgDynamicField[0]} showLabel={true} data={dropdownLabelVal}/>} 
                    value={orgRevenueDetails[orgDynamicField[0]]?.revenueAmount}
                />
            </Grid.Column>
            <Grid.Column>
                <InputField 
                    labelClassName="dropdown-label"
                    label={<>Recon <DropDownLabel value={orgDynamicField[0]} showLabel={true} data={dropdownLabelVal}/></>} 
                    value={reconRevenueDetails[orgDynamicField[0]]?.revenueAmount}
                />
            </Grid.Column>
        </Grid.Row>
    </> );
}
 
export default React.memo(EntrySummaryForm);